import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { Container, Typography, Grid, Box, Link } from '@mui/material';

function IPC() {
  return (
    <div style={{ backgroundColor: '#e3f2fd', paddingBottom: '40px' }}>
      <NavigationBar />
          <Typography variant="h5" fontWeight="bold" gutterBottom>
                       <br />  
          </Typography>
      <Container maxWidth="lg" sx={{ paddingTop: 5, paddingBottom: 5 }}>
        <Typography variant="h4" align="justify" gutterBottom sx={{ color: '#388E3C', fontWeight: 'bold' }}>
          Indice des Prix à la Consommation (IPC)
        </Typography>
        <Box sx={{ backgroundColor: '#ffffff', padding: 3, borderRadius: 2, boxShadow: 1 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <Typography variant="h6" align="left" gutterBottom sx={{ color: '#388E3C' }}>
                Informations Essentielles
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Taux d’inflation annuel (mars 2025):</strong> +26,1% (contre +23,8% en  février 2025) 
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="h6" align="left" gutterBottom sx={{ color: '#388E3C' }}>
                Détails des Finances Publiques
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Recettes totales (hors dons, T3 2024):</strong> 498.7 milliards de BIF
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Dons en capital (T2 2024):</strong> 61.6 milliards de BIF
              </Typography>
            </Grid>
          </Grid>

          <Typography variant="body1" align="left" paragraph sx={{ color: '#333', marginTop: 2,fontSize: 12 }}>
            Source : 
            <Link href="/documents/IndicesPrixConsommation/IPC-Fevrier-2025.pdf" target="_blank" sx={{ color: '#d32f2f', fontSize: 12 }}>
                Indice des Prix à la Consommation des ménages au Burundi,Mois de février 2025
            </Link>
          </Typography>
        </Box>
      </Container>
      <Footer />
    </div>
  );
}

export default IPC;